import React from 'react';
import cx from 'classnames';
import Accordion from '../Accordion';
import ChevronLink from '../ChevronLink';
import Grid from '../Grid';
import Heading from '../Heading';
import styles from './InfoPanel.module.scss';
const ContainerElement = ({ container, children, }) => {
    return <>{container ? <Grid.Container>{children}</Grid.Container> : children}</>;
};
export const InfoPanel = (props) => {
    const { className = '', items = [], terms = { title: 'Components/', description: '' }, title = '', analytics = () => { }, customLink, container = true, } = props;
    const onAccordionChange = ({ checked = false, title = '' } = {}) => {
        analytics({
            event: 'visitor interaction',
            interactionName: 'accordion click',
            linkText: (title || '').toLowerCase(),
            linkAction: checked ? 'open' : 'close',
        });
    };
    return (<>
      <ContainerElement container={container}>
        <div className={cx(styles.infoPanel, className)}>
          <Heading level={5} scale={2} className={styles.infoPanel__title}>
            {title}
          </Heading>
          <Grid.Row justify='center'>
            {items.map(({ id, title, description, href }, index) => (<Grid.Col key={id || index} className={styles.infoPanel__column}>
                <div className={styles.infoPanel__card}>
                  {customLink ? (<ChevronLink className={styles.infoPanel__link} level={7} text={title} href={href} CustomLink={customLink}/>) : (<a href={href}>{title}</a>)}
                  <div dangerouslySetInnerHTML={{ __html: description }}/>
                </div>
              </Grid.Col>))}
          </Grid.Row>
          {terms.description && (<Accordion title={terms.title} onChange={onAccordionChange}>
              {terms.description}
            </Accordion>)}
        </div>
      </ContainerElement>
    </>);
};
